module.exports = __webpack_public_path__ + "img/arrow_down.4d2f7c3f.svg";